import { render } from "./distributors.vue?vue&type=template&id=432b20a1&scoped=true"
import script from "./distributors.vue?vue&type=script&lang=js"
export * from "./distributors.vue?vue&type=script&lang=js"

import "./distributors.vue?vue&type=style&index=0&id=432b20a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432b20a1"]])

export default __exports__